import { Injectable } from "@angular/core";
import { BaseService } from "../../@core/services/base.service";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment.dev";

@Injectable({ providedIn: 'root' })
export class ConsumptionService extends BaseService {
    constructor(protected override http: HttpClient) {
        super(http);
    }

    apiUrl = environment.apiUrl + '/consumption';

    getConsumptionDetails(filter: {
        organization?: string,
        user?: string[],
        dateRange?: {
            startDate: Date,
            endDate: Date
        }
    }) {
        return this.post<{
            data: {
                date: string,
                tokens: number,
                cost: number,
            }[],
            totalCount: number,
            totalTokens: number,
            totalCost: number,
        }>(this.apiUrl, filter);
    }

    getTodaysConsumption(data: {
        isOrganizationConsumption: boolean,
    }) {
        return this.post<{
            totalTokens: number,
            totalCost: number,
        }>(this.apiUrl + '/today', data);
    }
}